import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M12 22v-5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 8V2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 8V2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Plug";
const Plug = memo(themed(Icon));
export {
  Plug
};
//# sourceMappingURL=plug.js.map
